<!--
App Icon

Add all icons here for central management.
Icons take props for:
 - color (the colour for the icon)
 - icon - (the given name for the icon - not the icons8 name)
 - size - (the size for the icon)
-->
<template>
	<div>
		<div v-for="item in icons" :key="item.name+item.reference">

			<v-icon v-if="icon === item.name"
					:class="item.reference"
					:color="color"
					:disabled="disabled"
					:size="size"/>

		</div>
	</div>
</template>

<script>
export default {

	data: () => ({
		icons: [

			// Pages

			// Accreditation
			{name: 'accreditation', reference: 'icons8-badge'},
			// App Support
			{name: 'support', reference: 'icons8-online-support'},
			// Events
			{name: 'events', reference: 'icons8-calendar'},
			// Event Day Dashboard
			{name: 'eventsDashboardDay', reference: 'icons8-event-accepted'},
			// Fire Roll Call
			{name: 'fireRollCall', reference: 'icons8-building-on-fire'},
			// Home
			{name: 'home', reference: 'icons8-home'},
			// Inductions
			{name: 'inductions', reference: 'icons8-checked-identification-documents'},
			// Log Out
			{name: 'logOut', reference: 'icons8-shutdown'},
			// My Profile
			{name: 'user', reference: 'icons8-user'},
			// Notice Board
			{name: 'noticeBoard', reference: 'icons8-noticeboard'},
			// Observations
			{name: 'eye', reference: 'icons8-eye'},
			// Organisations
			{name: 'organisation', reference: 'icons8-business-building'},
			// Parking
			{name: 'car', reference: 'icons8-car'},
			// Pre Event Dashboard
			{name: 'eventsDashboardPre', reference: 'icons8-event-accepted-tentatively'},
			// Qualifications
			{name: 'qualification', reference: 'icons8-certificate'},
			// Sites
			{name: 'sites', reference: 'icons8-skyscrapers'},
			// SWAPP
			{name: 'qrCode', reference: 'icons8-qr-code'},
			// Teams
			{name: 'teams', reference: 'icons8-business-group'},
			// Users
			{name: 'users', reference: 'icons8-people'},

			// App Icon
			{name: 'add', reference: 'icons8-add'},
			{name: 'archived', reference: 'icons8-archive'},
			{name: 'arrowBack', reference: 'icons8-back'},
			{name: 'arrowForward', reference: 'icons8-forward'},
			{name: 'camera', reference: 'icons8-camera'},
			{name: 'cancel', reference: 'icons8-cancel'},
			{name: 'check', reference: 'icons8-done'},
			{name: 'close', reference: 'icons8-close'},
			{name: 'closedEye', reference: 'icons8-closed-eye'},
			{name: 'columns', reference: 'icons8-select-column'},
			{name: 'delete', reference: 'icons8-trash'},
			{name: 'disabled', reference: 'icons8-assistive-technology'},
			{name: 'draft', reference: 'icons8-circle'},
			{name: 'edit', reference: 'icons8-edit'},
			{name: 'email', reference: 'icons8-at-sign'},
			{name: 'error', reference: 'icons8-error'},
			{name: 'export', reference: 'icons8-export'},
			{name: 'filter', reference: 'icons8-slider'},
			{name: 'imageColoured', reference: 'icons8-image'},
			{name: 'info', reference: 'icons8-info'},
			{name: 'menuDots', reference: 'icons8-menu-vertical'},
			{name: 'menuLines', reference: 'icons8-menu'},
			{name: 'minibus', reference: 'icons8-shuttle-bus'},
			{name: 'missingImage', reference: 'icons8-no-image'},
			{name: 'onHold', reference: 'icons8-private'},
			{name: 'orientation', reference: 'icons8-orientation'},
			{name: 'pending', reference: 'icons8-minus'},
			{name: 'phone', reference: 'icons8-phone'},
			{name: 'print', reference: 'icons8-print'},
			{name: 'reserved', reference: 'icons8-r'},
			{name: 'reservedParking', reference: 'icons8-valet-parking'},
			{name: 'save', reference: 'icons8-save'},
			{name: 'search', reference: 'icons8-search'},
			{name: 'send', reference: 'icons8-email-send'},
			{name: 'settings', reference: 'icons8-settings'},
			{name: 'success', reference: 'icons8-checkmark-yes'},
			{name: 'termsConditions', reference: 'icons8-terms-and-conditions'},
			{name: 'time', reference: 'icons8-clock'},
			{name: 'truck', reference: 'icons8-truck'},
			{name: 'upload', reference: 'icons8-upload'},
			{name: 'userDeleted', reference: 'icons8-denied'},
		]
	}),

	name: "AppIcon",

	props: ['color', 'disabled', 'icon', 'size']

}
</script>

<style scoped>

</style>
